/**
 * An global handler to efficent lazy load images.
 * This lazy load is optimized for vertical scrolling. All images above the
 * viewport will be loaded.
 * You can not use imga tags. LazyLoad only set CSS background image.
 * @type object
 */
var LazyLoad = {
  /**
   * An jQuery array with elements who should be handled
   * @type Array
   */
  _elements: [],
  /**
   * The css selector for the scroll event.
   * Default is 'main.mdl-layout__content'
   * @type type
   */
  _cssSelector: "main.mdl-layout__content",
  /**
   * Initialize the lazy load for the set of given elements.
   * If all elements are handeld, the scroll handler will be unbind.
   * All images in and above the viewport will be loaded.
   * @param {array} elements
   * Elements to be handled with lazy load. Each Element have to have the
   * data attribute <i>background_image</i>.
   * @param {string} cssSelector
   * Optional. CSS selector for the scroll event. Default is 'main.mdl-layout__content'
   * @returns {undefined}
   */
  init: function (elements, cssSelector) {
    //convert NodeList to array
    elements = [].slice.call(elements);
    this._elements = elements;

    //check if element from parameter is in DOM
    var scrollWrapperFound = false;
    if (typeof cssSelector !== "undefined") {
      if (document.querySelector(cssSelector) !== null) {
        scrollWrapperFound = true;
        this._cssSelector = cssSelector;
      } else {
        console.warn(
          'Element "' +
            cssSelector +
            '" not found. Try to find "' +
            this._cssSelector +
            '"'
        );
      }
    }
    //if not found yet, search for default
    if (
      !scrollWrapperFound &&
      document.querySelector(this._cssSelector) === null
    ) {
      //body is last option
      console.warn('"' + this._cssSelector + '" not found. Use body.');
      this._cssSelector = "body";
    }

    this._loadFunction();

    //call loadFunction because of animations.
    setTimeout(LazyLoad._loadFunction, 500);
    setTimeout(LazyLoad._loadFunction, 1000);

    document
      .querySelector(this._cssSelector)
      .addEventListener("scroll", LazyLoad._loadFunction);
  },
  /**
   * Here all elements will be checked if they are in viewport or above. If they
   * are, they background images for them would be loaded. Handeld items will be
   * removed from <i>lazyLoadBackgroundImages.elements</i>
   * This function is called on <i>lazyLoadBackgroundImages.init()</i>
   * and while scrolling.
   * @returns {Boolean}
   * <i>true</i> if the <i>lazyLoadBackgroundImages.elements</i>
   * contains not handeld elements
   * <i>false</i> if the <i>lazyLoadBackgroundImages.elements</i>
   * is now empty.
   */
  _loadFunction: function () {
    var that = LazyLoad;

    if (that._elements.length === 0) that._clear();

    var bodyHeight = window.innerHeight;

    for (var i = 0, len = that._elements.length; i < len; i++) {
      var item = that._elements[i];

      //only if element is visible
      if (
        item.parentNode.style.display !== "none" &&
        //-300 to load image 300px before it reaches the viewport
        item.getBoundingClientRect().top - 300 < bodyHeight
      ) {
        //set css background from data in item
        item.style.backgroundImage = item.dataset.background_image;

        //remove element from list
        that._elements.splice(i, 1);
        i--;
        len--;
      }
    }
  },
  /**
   * Clears the elements array and unbind the scroll handler.
   * @returns {undefined}
   */
  _clear: function () {
    this._elements = [];

    //unbind event listener
    document
      .querySelector(this._cssSelector)
      .removeEventListener("scroll", LazyLoad._loadFunction);
  },
};
